import { PriceDynamicsContainer, SupplyDemandContainer } from '../../../packages/MarketTrends';
import { useSelector } from 'react-redux';
import { Subtitle, TooltipContent } from 'shared/components/MarketTrends';
import { Section } from 'shared/components/Section';
import {
  selectMarketTrends,
  selectNearbyHousesInfo,
  selectSupplyDemand,
  selectShowMarketTrendsByFilters,
} from 'shared/selectors/marketTrends';
import { useFilters } from './hooks';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const MarketTrendsContainer = () => {
  const { logger } = useApplicationContext();

  const nearbyHousesInfo = useSelector(selectNearbyHousesInfo);

  const { showSupplyDemand, showPriceDynamic } = useSelector(selectShowMarketTrendsByFilters);

  const supplyDemandData = useSelector(selectSupplyDemand);

  const priceDynamicsData = useSelector(selectMarketTrends);

  const canShowPriceDynamics = showPriceDynamic && priceDynamicsData;

  const canShowSupplyDemand = showSupplyDemand && supplyDemandData;

  const filters = useFilters();

  if (!canShowPriceDynamics && !canShowSupplyDemand) {
    return null;
  }

  return (
    <Section
      title="Тренды на рынке недвижимости"
      dataName="MarketTrends"
      subtitleContent={
        nearbyHousesInfo.length > 0 ? (
          <Subtitle tooltipContent={<TooltipContent housesInfo={nearbyHousesInfo} />} />
        ) : undefined
      }
    >
      {canShowPriceDynamics && <PriceDynamicsContainer {...priceDynamicsData} {...filters} logger={logger} />}

      {canShowSupplyDemand && <SupplyDemandContainer {...supplyDemandData} logger={logger} />}
    </Section>
  );
};
